import type { Moment } from 'moment';
import { PeriodTypes } from './constants';
import { Values } from './objectEnums';
import { toMoment } from './date';
import getLastDeclaredPeriod from './getLastDeclaredPeriod';

type SchedulePeriod = {
	periodType: Values<typeof PeriodTypes>;
	to: Moment;
	maxTo?: Moment | null;
};

const extendLastDeclaredPeriodToMax = <T extends SchedulePeriod>(schedule: T[]): T[] => {
	const lastDeclared = getLastDeclaredPeriod(schedule);

	if (lastDeclared?.maxTo == null || !toMoment(lastDeclared.maxTo).isAfter(lastDeclared.to)) {
		return schedule;
	}

	const maxTo = toMoment(lastDeclared.maxTo);

	return schedule.map((s) => (s === lastDeclared ? { ...s, to: maxTo } : s));
};

export default extendLastDeclaredPeriodToMax;
